export const GET_SIGCHART_LIST_START = '@sigcharts/GET_SIGCHART_LIST_START'
export const GET_SIGCHART_LIST_SUCCESS = '@sigcharts/GET_SIGCHART_LIST_SUCCESS'
export const GET_SIGCHART_LIST_FAILURE = '@sigcharts/GET_SIGCHART_LIST_FAILURE'

export const SELECT_DOCUMENT = '@sigcharts/SELECT_DOCUMENT'

export const GET_SIGCHART_START = '@sigcharts/GET_SIGCHART_START'
export const GET_SIGCHART_SUCCESS = '@sigcharts/GET_SIGCHART_SUCCESS'
export const GET_SIGCHART_FAILURE = '@sigcharts/GET_SIGCHART_FAILURE'



// WEBPACK FOOTER //
// ./src/screens/sigcharts/actions/types.js